import toastr from "toastr";

require('./wdEventCommon');
window.$wdEventCommon.setType('events');

require('./registry');

if (!window.$eventCalls) {
	let ec = require('./eventCalls');
	window.$eventCalls = new ec.VioletEventCalls();
}

if (!window.$positionController) {
	require('./positionController');
	window.$positionController = new PositionController();
}

export class VioletEvent {
	defaultOptions() {
		return {
			eventId : null,
			flags : null,
			private : {
				originalState : null,
				originalStornoReason: null,
				relatedEventType: null,
				relinkEventId: null,
				relinkEventBootbox: null,
			},
		};
	}

	constructor() {
		var options = $('#js-opts').data('event');
		this.$options = $.extend({}, this.defaultOptions(), options || {});
		
		//Load original values
		this.$options.private.originalState = $('input#state').val();
		this.$options.private.originalStornoReason = $('input#storno_reason').val();
		
		this.initApp();
	}

	//-------------------------------------------------------------------------

	/**
	 * @param $button
	 */
	addVehicle($button) {
		let $buttonRow = $button.closest('.button-row'),
			$panelBody = $button.closest('.panel').find('.stagecoach-body');
		$buttonRow.addClass('hidden');
		$panelBody.removeClass('hidden');
		$('input#stagecoachExists').val('true');
	}

	/**
	 * @param $button
	 */
	removeVehicle($button) {
		let $buttonRow = $button.closest('.panel').find('.button-row'),
			$panelBody = $button.closest('.stagecoach-body');
		$buttonRow.removeClass('hidden');
		$panelBody.addClass('hidden');
		$('input#stagecoachExists').val('false');
	}
	
	//-------------------------------------------------------------------------
	
	printState(st) {
		let text = state;
		if (st in $Lang.events.states) {
			text = $Lang.events.states[st];
		}
		return text;
	}
	
	/**
	 * @param st
	 * @param action
	 */
	generateTimelineEntry(st, action) {
		let css = st.substr(2),
			html = "<div class=\"timeline-entry st-" + css + "\">" +
			"<div class=\"arrow-background square\"></div>" +
				"<div class=\"timline-entry-data\">" +
					"<span class='state " + css + "'>" + this.printState(st) + "</span>" +
					"<button class='btn btn-danger btn-xs btn-outline pull-right js-event-discard-state-change'><i class='fas fa-times'></i></button>" +
					"<div class=\"timeline-actions\">" + action + "</div>" +
					"<span class=\"timeline-date\"></span>" +
					"<span class=\"timeline-sheriff\"></span>" +
				"</div>" +
			"</div>";
		return html;
	}
	
	/**
	 * @param st
	 * @param action
	 */
	setState(st, action) {
		$('input#state').val(st);
		let $controls = $('.timleline-controls'),
			$controlsCell = $controls.parent();
		$controls.addClass('hidden');
		$controlsCell.append($(this.generateTimelineEntry(st, action)));
	}

	/**
	 * @param $button
	 */
	discardStateChange($button) {
		let $controls = $('.timleline-controls'),
			$appendedState = $button.closest('.timeline-entry');
		$appendedState.remove();
		$controls.removeClass('hidden');
		//Revert changed values
		$('input#state').val(this.$options.private.originalState);
		$('input#storno_reason').val(this.$options.private.originalStornoReason);
		//Remove any added attributes
		$('.control-button.js-close-event').removeAttr('disabled');
		$('.control-button.js-cancel-event').removeAttr('disabled');
	}

	/**
	 * @param st
	 */
	setReasonState(st) {
		let app = this;
		if (st in $Lang.events.closePrompt) {
			bootbox.prompt({
				title: $Lang.events.closePrompt[st],
				callback: function (result) {
					if (result) {
						let $input = $('input#storno_reason');
						$input.val(result);
						app.setState(st, result);
						
						$input.closest('form').submit();
						
						$('.control-button.js-close-event').attr('disabled', 'disabled');
						$('.control-button.js-cancel-event').attr('disabled', 'disabled');
					}
				},
				buttons: {
					cancel: {
						label: $Lang.common.cancel,
						className: 'btn-danger',
					},
					confirm: {
						label: $Lang.common.ok,
						className: 'btn-success',
					}
				},
			});
		}
		else {
			app.setState(st, "");
		}
	}
	
	//-------------------------------------------------------------------------

	/**
	 * 
	 * @param e
	 * @returns {boolean}
	 */
	checkDirty(e) {
		if (window.$wdEventCommon && window.$wdEventCommon.isDirty()) {
			bootbox.alert($Lang.registry.form.eventDirty);
			e.preventDefault();
			return false;
		}
		return true;
	}
	
	//-------------------------------------------------------------------------

	titleMaxlength(input) {
		let inputLength = input.val().length;
		const $counter = $('#event-title-maxlength');
		$counter.text(inputLength + "/50");
	}
	
	//-------------------------------------------------------------------------
	
	guiltChanged($li) {
		var value = $li.data('value'),
			$input = $($li.data('inputSelector'));

		$input.val(value).trigger('change');
	}
	
	//-------------------------------------------------------------------------

	initEditDialog(dialog, result) {		
		dialog.find('.bootbox-body').html(result);
		dialog.find('.js-whisperer-select').each(function (i, el) {
			window.$whisperers.initSelect($(el), dialog);
		});
	}

	saveTimelineForm(timelineID, dialog) {
		const app = this;
		const data = dialog.find('form').serializeArray();

		data.push({name: 'fullForm', value: true});

		$.ajax({
			url: route('events.updateTimeline', {'timeline': timelineID}),
			method: "post",
			dataType: "json",
			data: data,
			success: function (result) {
				let message = $Lang.events.timelineUpdated;

				if ('message' in result) {
					message = result.message;
				}
				toastr.success(message);

				// update UI
				// ---------------------------------------------
				const timelineEntry = $('#timeline-entry-' + timelineID);
				const actions = Object.values(timelineEntry.find('.action')).slice(0, -2);
				const datetime = $('#timeline-datetime-' + timelineID)[0];
				const sheriff = $('#timeline-sheriff-' + timelineID)[0];
				const sheriffSelect = dialog.find('#select2-timeline_sheriff-container')[0];

				data.map((input, index) => {
					if (input.name.startsWith("timeline_description"))
					{
						actions[index].innerText = input.value;
					}
					if (input.name == "timeline_datetime")
					{
						const value = input.value.split(" ");

						if (datetime.getAttribute('data-lastdate') == value[0]) {
							datetime.innerText = value[1];
						} else {
							datetime.innerText = input.value;
						}

						datetime.setAttribute('data-original-title', input.value)
					}
					if (input.name == "timeline_sheriff")
					{
						const sheriffID = sheriffSelect.innerText.split(" ")[0];
						sheriff.innerText = sheriffID;
						sheriff.setAttribute('data-original-title', sheriffSelect.innerText);
					}
				})
				// ---------------------------------------------
				
				dialog.modal('hide');
			},
			error: function (result) {
				if ('errors' in result.responseJSON) {
					inputErrors = result.responseJSON.errors;
					$customs.checkErrors();
				}

				let message = $Lang.common.unknownException;
				if ('responseJSON' in result && result.responseJSON && 'message' in result.responseJSON) {
					message = result.responseJSON.message;
				}
				toastr.error(message);
			}
		})
	}

	timelineEdit(btn) {
		const app = this;
		const timelineID = btn.attr('data-timeline');

		const dialog = bootbox.dialog({
			title: $Lang.events.editTimelineTitle,
			message: '<p><i class="fas fa-spin fa-spinner"></i>' + $Lang.common.loading + '</p>',
			buttons: {
				cancel: {
					label: $Lang.common.cancel,
					className: 'btn-danger',
				},
				ok: {
					label: $Lang.common.save,
					className: 'btn-success',
					callback: function() {
						app.saveTimelineForm(timelineID, dialog);
						return false;
					}
				}
			}
		});

		dialog.init(function() {
			$.ajax({
				url: route('events.editTimeline', {'timeline': timelineID}),
				method: "get",
				success: function (result) {
					app.initEditDialog(dialog, result);
				},
				error: function (a, b) {
					console.error(a, b);
				},
			});
		});
	}

	//-------------------------------------------------------------------------

	/**
	 * 
	 */
	alertSheriff() {
		//Process only if there are no changes to be saved
		if (window.$wdEventCommon.isDirty()) {
			bootbox.alert({
				'title': $Lang.events.saveFirstTitle,
				'message': $Lang.events.saveFirst,
			});
		}
		else {
			let app = this,
				dialog = bootbox.dialog({
					title: $Lang.events.selectSheriff,
					message: '<p><i class="fas fa-spin fa-spinner"></i>' + $Lang.common.loading + '</p>',
					buttons: {
						cancel: {
							label: $Lang.common.cancel,
							className: 'btn-danger',
						},
						ok: {
							label: $Lang.common.save,
							className: 'btn-success',
							callback: function () {
								app.submitSheriffForm(dialog);
								return false;
							}
						}
					}
				});
			dialog.init(function () {
				$.ajax({
					url: route('events.alertSheriffGet', {'event': app.$options.eventId}),
					method: "get",
					success: function (formData) {
						app.initSheriffDialog(dialog, formData);
					},
					error: function (a, b) {
						console.error(a, b);
					},
				});
			});
		}
		//Hide any tooltip that remained displayed after click
		$('.tooltip').hide();
	}

	initSheriffDialog(dialog, formData) {
		dialog.find('.bootbox-body').html(formData);
		dialog.find('.js-whisperer-select').each(function (i, el) {
			window.$whisperers.initSelect($(el), dialog);
		});
		window.setTimeout(function () {
			$customs.initBootstrapFeatures(dialog);
		}, 500);
	}

	alertSheriffSetRadio($cell, checkOnly) {
		let $checkbox = $cell.closest('tr').find('input[type=radio], input[type=checkbox]');
		if (checkOnly) {
			$checkbox.get(0).checked = true;
		} else {
			$checkbox.trigger('click');
		}
		
	}

	/*setFindSheriffId(val) {
		$('#alertSheriffFindRadio').val(val);
	}*/
	
	submitSheriffForm(dialog) {
		dialog.find('form').trigger('submit');
	}
	
	//-------------------------------------------------------------------------

	beaconUsageEdit(show) {
		const 	app = this,
				lang = $Lang.events;

		let dialog;

		if (!show)
		{
			dialog = bootbox.dialog({
				title: lang.beaconUsage,
				message: '<p><i class="fas fa-spin fa-spinner"></i>' + $Lang.common.loading + '</p>',
				buttons: {
					cancel: {
						label: $Lang.common.cancel,
						className: 'btn-danger',
					},
					ok: {
						label: $Lang.common.save,
						className: 'btn-success',
						callback: function() {
							app.saveBeaconForm(dialog);
							return false;
						}
					}
				}
			});
		}
		else
		{
			dialog = bootbox.dialog({
				title: lang.beaconUsage,
				message: '<p><i class="fas fa-spin fa-spinner"></i>' + $Lang.common.loading + '</p>',
				buttons: {
					cancel: {
						label: $Lang.common.close,
						className: 'btn-info'
					}
				}
			});
		}

		dialog.init(function() {
			$.ajax({
				url: route('events.editBeaconUsage'),
				method: "get",
				success: function (result) {

					const	beaconDetails = $('#beacon-details'),
							route = $('#beacon-detail-route').val(),
							RZ = $('#beacon-detail-rz').val(),
							driver = $('#beacon-detail-driver').val(),
							type = $('#beacon-detail-type').val();

					app.initEditDialog(dialog, result);

					if (show)
					{
						$('#bootbox-beacon-detail-route').attr('disabled', true);
						$('#bootbox-beacon-detail-rz').attr('disabled', true);
						$('#bootbox-beacon-detail-driver').attr('disabled', true);
						$('#bootbox-beacon-detail-type').attr('disabled', true);
					}

					$('#bootbox-beacon-detail-route').val(route);
					$('#bootbox-beacon-detail-rz').val(RZ);
					$('#bootbox-beacon-detail-driver').val(driver);
					$('#bootbox-beacon-detail-type').val(type);

					beaconDetails.addClass('visible');
				},
				error: function (a, b) {
					console.error(a, b);
				},
			});
		});
	}

	saveBeaconForm(dialog) {

		const	route = $('#bootbox-beacon-detail-route').val(),
		RZ = $('#bootbox-beacon-detail-rz').val(),
		driver = $('#bootbox-beacon-detail-driver').val(),
		type = $('#bootbox-beacon-detail-type').val();

		$('#beacon-detail-route').val(route);
		$('#beacon-detail-rz').val(RZ);
		$('#beacon-detail-driver').val(driver);
		$('#beacon-detail-type').val(type);

		dialog.modal('hide');
	}

	//-------------------------------------------------------------------------

	linkRelatedEvent(button) {
		this.$options.private.relatedEventType = button.data('related-event-type');
		this.$options.private.relinkEventId = parseInt(button.data('relink-event-id'));

		const dialog = bootbox.dialog({
			message: "Loading...",
			title: $Lang.events.calls.findEvent,
			size: 'large',
			buttons: {
				cancel: {
					label: $Lang.common.cancel,
					className: 'btn-danger',
					callback: function() {
						dialog.modal('hide');
						$('#js-opts-common').removeData('relink');
					}
				}
			},
		})
		$.ajax({
			type: "post",
			url: route('events.getList', {}),
			success: function (r) {
				const $body = dialog.find('div.bootbox-body');

				$body.addClass("bb-events-list");
				$body.css("max-height", "" + ($(window).height() - 150) + "px");
				$body.html(r);

				window.$sbAdminDatatables.initDataTable($body.find('.js-data-table'));
			},
			error: function(r) {
				const $body = dialog.find('div.bootbox-body');
				$body.html($Lang.events.calls.loadingEventsFailed);
			},
		});
		this.$options.private.relinkEventBootbox = dialog;
	}

	saveRelatedEvent(button) {
		const app = this,
			relinkEventId = app.$options.private.relinkEventId,
			chosenEventId = parseInt(button.data('eventId')),
			dialog = app.$options.private.relinkEventBootbox,
			type = app.$options.private.relatedEventType,
			url = relinkEventId
				? route('events.linkRelatedEvent', {
					'event': relinkEventId
				})
				: route('events.linkRelatedEvent', {
					'event': type === 'parent' ? parseInt(app.$options.eventId) : chosenEventId
				});

		if (dialog) {
			dialog.modal('hide');
			app.$options.private.relinkEventBootbox = null;

			$.ajax({
				type: "post",
				url: url,
				data: {
					action: relinkEventId ? 'relink' : 'add',
					eventId: parseInt(app.$options.eventId),
					chosenEventId: chosenEventId
				},
				success: function (r) {
					if (r && ('success' in r) && (r.success)) {
						toastr.success(r.success);
						
						if (('redirect' in r) && (r.redirect)) {
							window.location.href = r.redirect;
						}
					} else {
						toastr.error($Lang.common.unknownException);
					}
				},
				error: function (r) {
					let msg = $Lang.common.unknownException;
					if (r.responseJSON && ('error' in r.responseJSON) && r.responseJSON.error) {
						msg = r.responseJSON.error;
					}
					else if (r.statusText) {
						msg += "(" + r.statusText + ")";
					}
					console.error(r);
					toastr.error(msg);
				}
			});
		}

		app.$options.private.relinkEventId = null;
	}

	//-------------------------------------------------------------------------

	/**
	 *
	 */
	initApp() {
		var app = this,
			$options = app.$options;
		
		$options.eventId = $('input#input_event_id').val();
		$options.flags = $('input#event_flags').val();
		
		//newly created event - set default panels layout
		/*if (!$options.eventId && !$options.flags)
		{
			window.$wdEventCommon.initPanels($('#eventTypeId'));
		}*/
		app.initButtons();
		app.titleMaxlength($('#title'));
		
		window.$wdEventCommon.setId($options.eventId);
	}
		
	/**
	 * 
	 */
	initButtons() {
		var app = this,
			$document = $(document),
			eventStates = window.$Common.events.states;
		
		$document.on('change', '#eventTypeId', function () {
			$wdEventCommon.initPanels($(this));
		});
		
		$document.on('input', '#title', function () {
			app.titleMaxlength($(this));
		});
		
		$document.on('click', '#add-stagecoach', function (e) {
			e.preventDefault();
			app.addVehicle($(this));
		});
		$document.on('click', '#remove-stagecoach', function (e) {
			e.preventDefault();
			app.removeVehicle($(this));
		});

		$document.on('click', '.js-make-wd-button', function (e) {
			return app.checkDirty(e);
		});
		
		$document.on('click', '.event-guilt-level-tabs > li', function () {
			app.guiltChanged($(this));
		});
		
		//---------------------------------------------------------------------
		// State changing methods
		//---------------------------------------------------------------------
		
		$document.on('click', '.js-set-event-processing', function (e) {
			e.preventDefault();
			app.setState(eventStates.STATE_PROCESSING, "");
		});
		$document.on('click', '.js-alert-sheriff', function (e) {
			e.preventDefault();
			app.alertSheriff();
		});
		$document.on('click', '.js-set-alert-sheriff-radio', function (e) {
			e.preventDefault();
			let $td = $(this);
			app.alertSheriffSetRadio($td, $td.hasClass('js-only-check'));
		});
		/*$document.on('change', '#alertSheriffFindSheriff', function (e) {
			e.preventDefault();
			app.setFindSheriffId($(this).val());
		});*/
		$document.on('click', '.js-event-accept', function (e) {
			e.preventDefault();
			app.setState(eventStates.STATE_SHERIFF_ACCEPTED, "");
			$(this).closest('form').submit();
		});
		$document.on('click', '.js-event-start-action', function (e) {
			app.setState(eventStates.STATE_SHERIFF_ACTION_STARTED, "");
			return true;
		});
		$document.on('click', '.js-close-event', function (e) {
			e.preventDefault();
			app.setReasonState(eventStates.STATE_CLOSED);
			return true;
		});
		$document.on('click', '.js-cancel-event', function (e) {
			e.preventDefault();
			app.setReasonState(eventStates.STATE_STORNO);
			
			return true;
		});
		$document.on('click', '.js-event-discard-state-change', function (e) {
			e.preventDefault();
			app.discardStateChange($(this));
		});
		
		//---------------------------------------------------------------------
		
		// $document.on('click', '.js-call-download-and-play', function (e) {
		// 	e.preventDefault();
		// 	app.downloadAndPlay($(this));
		// });
		$document.on('click', '.js-event-timeline-edit', function (e) {
			e.preventDefault();
			app.timelineEdit($(this));
		});
		$document.on('change', '#beacon', function () {
			if ($(this).is(':checked'))
			{
				app.beaconUsageEdit();
			}
			else
			{
				$('#beacon-details').removeClass('visible');
			}
		});
		$document.on('click', '#beacon-details a', function (e) {
			e.preventDefault();

			let show = $('#beacon-details').data('show');

			app.beaconUsageEdit(show);
		});
		$document.on('click', '.js-related-event', function () {
			$('#js-opts-common').data('relink', 'related-event');
			app.linkRelatedEvent($(this));
		});
		$document.on('click', '.js-relink-button', function (e) {
			e.preventDefault();
			if ($('#js-opts-common').data('relink') === 'related-event') {
				app.saveRelatedEvent($(this));
				$('#js-opts-common').removeData('relink');
			}
		});
	}

}
